let refreshPromise = null;

const getApiBaseUrl = ({ host, domain, subDomain, apiSubDomain }) => {
  let apiBaseUrl;
  if (host.indexOf('localhost') > -1) {
    apiBaseUrl = `http://localhost:3003/api`;
  } else {
    // detect env
    const parts = host.split('.');
    // Only qa/uat are real environments; any other segment before 'prosolve.com' means prod
    const envPart = parts[parts.length - 3];
    const env = ['qa', 'uat'].includes(envPart) ? `.${envPart}` : '';
    apiBaseUrl = `https://${apiSubDomain}.${subDomain}${env}.${domain}/api`;
  }
  return apiBaseUrl;
}

export default () => {
  const host = window.location.host;
  const domain = 'prosolve.com';
  const subDomain = 'root';
  const apiSubDomain = 'api';

  const apiBaseUrl = getApiBaseUrl({ host, domain, subDomain, apiSubDomain })

  // Example of when this gets lifted to other projects...how the below refreshAccessToken must use the rootBaseUrl
  // const rootBaseUrl = getApiBaseUrl({ host, domain, subDomain: 'root', apiSubDomain })

  // Single-flight refresh helper
  const refreshAccessToken = async () => {
    if (!refreshPromise) {
      refreshPromise = fetch(`${apiBaseUrl}/auth/refresh`, {
        method: 'POST',
        credentials: 'include',
        // header optional, but often nice to include
        headers: { 'Content-Type': 'application/json' },
      }).finally(() => {
        refreshPromise = null;
      });
    }

    const res = await refreshPromise;
    if (!res.ok) {
      // refresh failed (401/403/etc.) => treat as logged out upstream
      const err = new Error(`Refresh failed with status ${res.status}`);
      err.status = res.status;
      throw err;
    }
    return res;
  };

  return async (url, options = {}, ...args) => {
    // Ensure credentials always include cookies
    const optionsOverride = {
      ...options,
      credentials: 'include',
    };

    // Helper to perform the actual request (so we can retry cleanly)
    const doRequest = () => fetch(`${apiBaseUrl}/${url}`, optionsOverride, ...args);

    let res = await doRequest();

    // If unauthorized, try refresh once then retry request once
    if (res.status === 401) {
      // Prevent infinite loop: don't try to refresh if we're already calling refresh
      // (handles cases where caller passes url like "auth/refresh" or "/auth/refresh")
      const normalizedUrl = String(url).replace(/^\//, '');
      if (!normalizedUrl.startsWith('auth/refresh')) {
        try {
          await refreshAccessToken();
          res = await doRequest(); // retry once
        } catch (e) {
          // Only force logout on "auth is invalid" responses.
          // If refresh failed due to 401/403 -> token expired/invalid -> logout.
          if (e?.status === 401 || e?.status === 403) {
            // Trigger logout event
            window.dispatchEvent(new CustomEvent("auth:logout", {}));
          }
          // If refresh fails, return the original 401 response (or you can throw)
          // Minimal-change behavior: just return the 401 response so callers can handle it.
          return res;
        }
      }
    }

    return res;
  };
};